module.exports = __webpack_public_path__ + "img/history.9a0b9130.svg";